module.exports = __webpack_public_path__ + "img/border.e7309194.png";